addEventListener("DOMContentLoaded", () => {
    const lenis = new Lenis({
        autoRaf: true,
    });
})

document.querySelectorAll(".navegacao").forEach(nav => {
	const elementoId = nav.getAttribute("elemento");
	const alvo = document.getElementById(elementoId);
	if (!alvo) return;

	const botoesNav = nav.querySelectorAll(".icone");
	const isTouch = window.matchMedia("(hover: none), (pointer: coarse)").matches;

	if (!isTouch) {
		alvo.addEventListener("wheel", e => e.preventDefault(), { passive: false });
		alvo.addEventListener("touchmove", e => e.preventDefault(), { passive: false });
	}

	const EPS = 2;

	function maxScroll() {
		return Math.max(0, alvo.scrollWidth - alvo.clientWidth);
	}

	botoesNav[0]?.addEventListener("click", () => {
		const largura = alvo.clientWidth;
		const max = maxScroll();

		if (alvo.scrollLeft <= EPS) {
			alvo.scrollTo({ left: max, behavior: "smooth" });
			return;
		}

		alvo.scrollBy({ left: -largura, behavior: "smooth" });
	});

	botoesNav[1]?.addEventListener("click", () => {
		const largura = alvo.clientWidth;
		const max = maxScroll();

		if (alvo.scrollLeft >= max - EPS) {
			alvo.scrollTo({ left: 0, behavior: "smooth" });
			return;
		}

		alvo.scrollBy({ left: largura, behavior: "smooth" });
	});
});

// Sequência do Slider do Início (todos os projetos)
addEventListener("DOMContentLoaded", () => {
    const slider = document.querySelector("body:not(.pag-projeto) .inicio .slider");
    if (!slider) return;

    const nav        = document.querySelector(".inicio .navegacao");
    const detalhesEl = gsap.utils.toArray(".inicio .projetos .projeto .detalhes");
    const dadosEl    = gsap.utils.toArray(".inicio .projetos .projeto .dados");

    function posicionarInicial() {
        if (nav) {
            const h = nav.offsetHeight || 0;
            gsap.set(nav, {bottom: -(h + 1) });
        }

        detalhesEl.forEach(el => {
            const h = el.offsetHeight || 0;
            gsap.set(el, {bottom: -(h + 1) });
        });

        dadosEl.forEach(el => {
            const h = el.offsetHeight || 0;
            gsap.set(el, { position: "relative", bottom: -(h + 1) });
        });
    }

    posicionarInicial();

    // timeline: nav + TODOS os .detalhes juntos -> depois TODOS os .dados
    const tl = gsap.timeline({
        paused: true,
        defaults: { duration: 0.25, ease: "power1.out" }
    });

    const grupo1 = [nav, ...detalhesEl].filter(Boolean); // nav + detalhes
    if (grupo1.length) tl.to(grupo1, { bottom: 0 }, 0);
    if (dadosEl.length) tl.to(dadosEl, { bottom: 0 }, ">");

    // Hover controla a timeline
    slider.addEventListener("mouseenter", () => tl.play());
    slider.addEventListener("mouseleave", () => tl.reverse());

    // Recalcular em resize (caso mude alturas)
    let to;
    window.addEventListener("resize", () => {
        clearTimeout(to);
        to = setTimeout(() => {
            tl.progress(0).pause();
            posicionarInicial();
        }, 150);
    });

    // (Opcional) garantir após imagens carregarem
    window.addEventListener("load", () => {
        tl.progress(0).pause();
        posicionarInicial();
    });
});

// addEventListener("DOMContentLoaded", () => {
//     const carrosseis = Array.from(document.querySelectorAll(".carrosel"));
//     let uid = 0;

//     carrosseis.forEach(car => {
//         // garante que o .carrosel tem um id (atributo 'elemento' da navegação aponta para ele)
//         if (!car.id) {
//             car.id = `carrosel-${++uid}`;
//         }

//         // tenta limitar a busca ao mesmo bloco/section que contém o carrossel
//         const scope = car.closest("section, .imagem, .bloco, .container") || car.parentElement || document;
//         let nav = scope.querySelector(`.navegacao[elemento="${car.id}"]`);
//         if (!nav) {
//             // fallback global, caso a estrutura seja diferente
//             nav = document.querySelector(`.navegacao[elemento="${car.id}"]`);
//         }
//         if (!nav) return; // sem navegação, nada a fazer

//         // área de hover: o contêiner que agrupa carrossel + navegação (normalmente .imagem)
//         const hoverArea = nav.parentElement?.contains(car) ? nav.parentElement : (car.parentElement || car);

//         // posiciona a nav escondida
//         const setHidden = () => {
//             const h = nav.offsetHeight || 0;
//             nav.dataset._off = String(h + 1);
//             gsap.set(nav, { bottom: -(h + 1) });
//         };
//         setHidden();

//         // animações
//         const show = () => gsap.to(nav, { bottom: 0, duration: 0.25, ease: "power1.out" });
//         const hide = () => gsap.to(nav, { bottom: -(parseFloat(nav.dataset._off || "0")), duration: 0.25, ease: "power1.in" });

//         // eventos
//         hoverArea.addEventListener("mouseenter", show);
//         hoverArea.addEventListener("mouseleave", hide);

//         // recalcula se o layout mudar (ex: imagens carregam, resize)
//         const recalc = () => {
//             // congela no estado inicial antes de medir novamente
//             gsap.killTweensOf(nav);
//             setHidden();
//         };
//         // após todas as imagens do bloco
//         if (scope instanceof Element) {
//             const imgs = scope.querySelectorAll("img");
//             imgs.forEach(img => {
//                 if (!img.complete) img.addEventListener("load", recalc, { once: true });
//             });
//         }
//         let resizeTO;
//         window.addEventListener("resize", () => {
//             clearTimeout(resizeTO);
//             resizeTO = setTimeout(recalc, 150);
//         });
//     });
// });

addEventListener("DOMContentLoaded", () => {
    // 🔹 Coleta todos os "cards" dos dois tipos
    const itens = gsap.utils.toArray([
        ".ultimos-projetos .galeria > li",
        ".apartamento-caixa .imagem"
    ]);

    const timelines = new WeakMap();

    function medirAltura(el) { return el ? el.offsetHeight || 0 : 0; }

    function setInicial(detalhes, dados, botao) {
        const hDet = medirAltura(detalhes);
        const hDad = medirAltura(dados);
        const hBot = medirAltura(botao);
        if (detalhes) gsap.set(detalhes, { bottom: -(hDet + 1) });
        if (dados)    gsap.set(dados,    { position: "relative", bottom: -(hDad + 1) });
        if (botao)    gsap.set(botao,    { bottom: -(hBot + hDet + 1)});
    }

    function criarTimeline(card, detalhes, dados, botao) {
        const tl = gsap.timeline({ paused: true, defaults: { duration: 0.25, ease: "power1.out" } });
        if (detalhes) tl.to(detalhes, { bottom: 0 }, 0);
        if (dados)    tl.to(dados,    { bottom: 0 }, ">");
        if (botao)    tl.to(botao,    { bottom: 0 }, 0); // sobe junto com detalhes

        tl.eventCallback("onStart", () => {
            card.classList.add("_animando");
        });
        tl.eventCallback("onReverseComplete", () => {
            card.classList.remove("_animando");
        });

        timelines.set(card, tl);
        return tl;
    }

    function prepararCard(card) {
        const detalhes = card.querySelector(".detalhes");
        const dados    = card.querySelector(".detalhes .dados");
        const botao    = card.querySelector(".botao"); // novo
        if (!detalhes && !dados && !botao) return;

        setInicial(detalhes, dados, botao);

        const tlAntiga = timelines.get(card);
        if (tlAntiga) tlAntiga.kill();
        const tl = criarTimeline(card, detalhes, dados, botao);

        // 🔹 Hover: .imagem nos apartamentos, <a> nos projetos
        const hoverArea = card.closest(".apartamento-caixa") 
            ? card.closest(".apartamento-caixa") // hover na caixa inteira
            : card.querySelector("a") || card;   // hover no link nos projetos

        hoverArea.onmouseenter = () => tl.play();
        hoverArea.onmouseleave = () => tl.reverse();

        // 🔹 Recalcula se imagem for carregada depois
        card.querySelectorAll("img").forEach(img => {
            if (!img.complete) img.addEventListener("load", () => {
                tl.progress(0).pause();
                setInicial(detalhes, dados, botao);
            }, { once: true });
        });
    }

    itens.forEach(prepararCard);

    // 🔹 Atualiza no resize
    let to;
    window.addEventListener("resize", () => {
        clearTimeout(to);
        to = setTimeout(() => {
            itens.forEach(card => {
                const detalhes = card.querySelector(".detalhes");
                const dados    = card.querySelector(".detalhes .dados");
                const botao    = card.querySelector(".botao");
                const tl = timelines.get(card);
                if (tl) tl.progress(0).pause();
                setInicial(detalhes, dados, botao);
            });
        }, 150);
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('header');
    const menuItems = document.querySelectorAll('header nav > ul > li');
    const submenu = document.querySelector('li.submenu');
    const apartamentos = document.querySelector('.apartamentos');

    if (!header || !submenu || !apartamentos) return;

    // hover nos itens do menu
    menuItems.forEach(item => {
        item.addEventListener('mouseenter', () => {
            if (item === submenu) {
                submenu.classList.add('aberto');
                apartamentos.classList.add('aberto');
            } else {
                submenu.classList.remove('aberto');
                apartamentos.classList.remove('aberto');
            }
        });
    });

    // 👉 sai do header → fecha tudo
    header.addEventListener('mouseleave', () => {
        submenu.classList.remove('aberto');
        apartamentos.classList.remove('aberto');
    });
});



document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.missao-visao-e-valores .conteudo').forEach(conteudo => {
        const expansivel = conteudo.querySelector('.expansivel');
        conteudo.addEventListener('click', () => {
            const aberto = conteudo.classList.toggle('aberto');
            expansivel.style.height = aberto ? expansivel.scrollHeight + 'px' : '0';
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const checkbox = document.querySelector('.termos .checkbox .box');
    const termosbox = document.querySelector('.termos');
    const submit = document.querySelector('input[type="submit"]');

    if (checkbox && submit) {
        checkbox.addEventListener('click', () => {
            termosbox.classList.toggle('aceite');
            submit.disabled = !termosbox.classList.contains('aceite');
        });
    }
});

document.addEventListener("DOMContentLoaded", () => {
	// limita ao teu contexto (ajusta se necessário)
	document.querySelectorAll(".pag-projeto .projetos .projeto").forEach(projeto => {
		const imagemPrincipal = projeto.querySelector(":scope > img"); // img principal (filha direta)
		const duplicadaImg = projeto.querySelector(".img-duplicada img");

		const carrosel = projeto.querySelector(":scope > .carrosel");
		const thumbs = Array.from(carrosel?.querySelectorAll(":scope > .imagem img") || []);

		// navegação (anterior / próximo)
		const nav = projeto.querySelector(":scope > .navegacao");
		const btnAnterior = nav?.querySelector(":scope > .icone:nth-child(1)");
		const btnProximo = nav?.querySelector(":scope > .icone:nth-child(2)");

		if (!imagemPrincipal || !duplicadaImg || !carrosel || thumbs.length === 0) return;

		let indiceAtual = 0;
		let intervalo = null;
		let pausado = false;
		let animando = false;

		const DUR = 400;      // tem que bater com o CSS (0.4s)
		const AUTOPLAY = 4000;

		// cache simples para não “rebaixar” downloads repetidos
		const cache = new Set();

		function preload(src) {
			if (!src || cache.has(src)) return Promise.resolve();

			return new Promise(resolve => {
				const tmp = new Image();
				tmp.onload = () => {
					cache.add(src);
					resolve();
				};
				tmp.onerror = () => resolve(); // não trava
				tmp.src = src;
			});
		}

		function marcarThumbAtiva(indice) {
			const wrappers = Array.from(carrosel.querySelectorAll(":scope > .imagem"));
			wrappers.forEach(w => w.classList.remove("activa"));
			const w = wrappers[indice];
			if (w) w.classList.add("activa");
		}

		async function ativarImagem(indice) {
			if (animando) return;
			const thumb = thumbs[indice];
			if (!thumb) return;

			const novoSrc = thumb.getAttribute("src") || thumb.src;
			const novoAlt = thumb.getAttribute("alt") || thumb.alt || "";

			// se já estiver na mesma imagem, não faz nada
			if ((imagemPrincipal.currentSrc || imagemPrincipal.src) === novoSrc) {
				marcarThumbAtiva(indice);
				indiceAtual = indice;
				return;
			}

			animando = true;
			indiceAtual = indice;
			marcarThumbAtiva(indice);

			// garante que a imagem já está “pronta” antes da transição
			await preload(novoSrc);

			// 1) mete a duplicada com o novo src (a duplicada é quem faz o fade-in)
			duplicadaImg.src = novoSrc;
			duplicadaImg.alt = novoAlt;

			// 2) força transição (0 -> 1)
			duplicadaImg.style.opacity = "0";
			void duplicadaImg.offsetWidth; // reflow
			duplicadaImg.style.opacity = "1";

			// 3) depois do DUR, troca a principal e esconde a duplicada
			setTimeout(() => {
				imagemPrincipal.src = novoSrc;
				imagemPrincipal.alt = novoAlt;

				duplicadaImg.style.opacity = "0";

				// pequena folga pra não “libertar” no meio do CSS
				setTimeout(() => (animando = false), 50);
			}, DUR);
		}

		function proximo() {
			ativarImagem((indiceAtual + 1) % thumbs.length);
		}

		function anterior() {
			ativarImagem((indiceAtual - 1 + thumbs.length) % thumbs.length);
		}

		// clique nas thumbs
		thumbs.forEach((img, i) => {
			const wrapper = img.closest(".imagem");

			(wrapper || img).addEventListener("click", () => ativarImagem(i));

			// preload ao “hover” (como pediste antes, ajuda no feeling)
			(wrapper || img).addEventListener("mouseenter", () => {
				const src = img.getAttribute("src") || img.src;
				preload(src);
			});
		});

		// navegação anterior / próximo
		if (btnAnterior) {
			btnAnterior.addEventListener("click", e => {
				e.preventDefault();
				anterior();
			});
		}
		if (btnProximo) {
			btnProximo.addEventListener("click", e => {
				e.preventDefault();
				proximo();
			});
		}

		// autoplay
		function iniciarAutoplay() {
			if (intervalo) clearInterval(intervalo);
			if (thumbs.length < 2) return; // não faz sentido com 0/1 imagem

			intervalo = setInterval(() => {
				if (pausado || animando) return;
				proximo();
			}, AUTOPLAY);
		}

		// pausa quando o rato está no projeto (carousel + navegação + etc)
		projeto.addEventListener("mouseenter", () => (pausado = true));
		projeto.addEventListener("mouseleave", () => (pausado = false));

		// init
		ativarImagem(0);
		iniciarAutoplay();
	});
});

function ajustarInicioProjeto() {
    const inicio = document.querySelector(".pag-projeto .inicio");
    const h1 = document.querySelector(".pag-projeto .projeto .detalhes h1");
    if (!inicio || !h1) return;
    const h1Height = h1.offsetHeight;
    inicio.style.height = `calc(100dvh - var(--tamanho) - ${h1Height}px)`;
}
window.addEventListener("load", ajustarInicioProjeto);
window.addEventListener("resize", ajustarInicioProjeto);

document.addEventListener("DOMContentLoaded", () => {
    const duracao = 3000;

    // começa rápido e termina lento
    const easing = t => 1 - Math.pow(1 - t, 4); // easeOutQuart

    const formatar = (valor, casas) =>
        valor.toFixed(casas).replace(".", ",");

    const observer = new IntersectionObserver((entradas, obs) => {
        entradas.forEach(entrada => {
            if (!entrada.isIntersecting) return;

            const dd = entrada.target;

            // 👉 apenas o TEXTO (antes do span)
            const textoNode = Array.from(dd.childNodes)
                .find(n => n.nodeType === Node.TEXT_NODE);

            if (!textoNode) return;

            const textoFinal = textoNode.textContent.trim();

            const valorFinal = parseFloat(textoFinal.replace(",", "."));
            const casas = (textoFinal.split(",")[1] || "").length;

            let inicio = null;

            function animar(timestamp) {
                if (!inicio) inicio = timestamp;

                const progresso = Math.min((timestamp - inicio) / duracao, 1);
                const valor = valorFinal * easing(progresso);

                textoNode.textContent = formatar(valor, casas);

                if (progresso < 1) {
                    requestAnimationFrame(animar);
                } else {
                    textoNode.textContent = textoFinal; // garante valor exacto
                }
            }

            // começa do zero
            textoNode.textContent = formatar(0, casas);
            requestAnimationFrame(animar);

            obs.unobserve(dd);
        });
    }, { threshold: 0.6 });

    document.querySelectorAll("dl .classificacao dd").forEach(dd => {
        observer.observe(dd);
    });
});




document.addEventListener("DOMContentLoaded", () => {
    
    const header = document.querySelector('header');
    const botoes = document.querySelectorAll('.hamburguer');

    const btnHamburguer = botoes[0];
    const btnFechar = botoes[1];

    // estado inicial
    btnFechar.style.display = 'none';

    btnHamburguer.addEventListener('click', () => {
        header.classList.add('aberto');
        btnHamburguer.style.display = 'none';
        btnFechar.style.display = 'block';
    });

    btnFechar.addEventListener('click', () => {
        header.classList.remove('aberto');
        btnFechar.style.display = 'none';
        btnHamburguer.style.display = 'block';
    });

});

document.addEventListener("DOMContentLoaded", () => {

	const form = document.querySelector("#formulario")
	if (!form) return

	let resposta = form.querySelector(".resposta")

	if (!resposta) {
		resposta = document.createElement("div")
		resposta.className = "resposta"
		form.appendChild(resposta)
	}

	form.addEventListener("submit", async (e) => {

		e.preventDefault()

		resposta.textContent = ""
		resposta.classList.remove("erro", "sucesso")

		const dados = new FormData(form)

		try {

			const r = await fetch("/mail.php", {
				method: "POST",
				body: dados
			})

			const json = await r.json()

			if (json.sucesso) {

				resposta.classList.add("sucesso")
				resposta.textContent = "Formulário submetido com sucesso, entraremos em contacto em breve."
				form.reset()

			} else {

				resposta.classList.add("erro")
				resposta.textContent = json.mensagem || "Tente novamente mais tarde, por favor."

			}

		} catch (erro) {

			resposta.classList.add("erro")
			resposta.textContent = "Tente novamente mais tarde, por favor."

		}

	})

})


document.addEventListener("DOMContentLoaded", () => {

	const caixa = document.querySelector(".idiomas-caixa")
	if (!caixa) return

	let pagina = window.location.pathname.split("/").pop() || "index"

	pagina = pagina.replace(".html", "")
	pagina = pagina.replace(/_en$/, "")

	const links = caixa.querySelectorAll("a")
	if (links.length < 2) return

	links[0].setAttribute("href", pagina)
	links[1].setAttribute("href", pagina + "_en")

})